/**
 * NOTIFICATION-WEB-PUSH-C2 — mirror canonical unread count via Badging API.
 * Feature-detected; never a source of truth; never throws into bootstrap.
 * Only safe non-negative integers are accepted — no Number() coercion.
 */

export function setAppBadgeFromUnreadCount(count) {
  try {
    if (typeof navigator === 'undefined') return;
    if (!Number.isSafeInteger(count) || count < 0) return;

    if (count > 0) {
      if (typeof navigator.setAppBadge === 'function') {
        const result = navigator.setAppBadge(count);
        if (result && typeof result.catch === 'function') {
          result.catch(() => {});
        }
      }
      return;
    }

    if (typeof navigator.clearAppBadge === 'function') {
      const result = navigator.clearAppBadge();
      if (result && typeof result.catch === 'function') {
        result.catch(() => {});
      }
    }
  } catch (_err) {
    // Contained — badge must never break auth/bootstrap.
  }
}

export function clearAppBadge() {
  setAppBadgeFromUnreadCount(0);
}
